import { PortalErrorStateScheduleEnum } from './portal-error-state-schedule.enum';

export enum PortalCashOperationsDepositAddComponentErrorStatesEnum {
  RegisterBankAccountFailed = PortalErrorStateScheduleEnum.CashOperationsDepositAddComponentErrorStatesStartIndex,
  GetLinkedAccountsFailed,
  GetLinkedAccountsInvalidData,
  CreateDepositFailed
}
